module.exports = __webpack_public_path__ + "media/images/arrow-up-c7a255705da2a986d6923cdb59b55c80.svg";